<template>
  <main class="detail-message">
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>{{ $t('title.detailsMsgSend') }}</h3>
          </template>

          <template v-slot:right-element>
            <div class="d-flex buttons-wrapper">
              <a @click="previewAction()" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t('button.retour') }}
              </a>
            </div>
          </template>
        </TopTemplate>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else>
      <div class="row">

        <div class=" col-md-9 top-card">

          <div class=" card ">
            <div class="content-msg-title">
              <h3>Contenu</h3>
            </div>

            <div class="row top-msg ">
              <div class="col-md-6 content-msg">
                <p><strong>Expéditeur :</strong> {{ nameFrom }} {{ lastNameFrom }} </p>
                <p><strong>Date : </strong>Le {{ formatDateString(reference.created_at) }} </p>
                <div class="content-msg__bottom">
                  <p> <strong>Message : </strong> <span :class="{ 'arab-text': checkLanguag(reference.message) }"
                      class="text-normal content-editor" v-html="reference.message"></span></p>
                </div>
              </div>
              <div class="col-md-4">
                <span v-if="files.length === 0">
                  {{ $t("common.emptyFiles") }}
                </span>
                <span v-else class="col-md-5" v-for="(file, index) in files" :key="index"><i class="icon-file-04"></i>
                  <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="general-info">
            <h1>{{ $t('title.message') }} </h1>
            <div class="justify-content-center">
              <DonutChart v-if="displayGraph" :chart-data="chartDataMessage" :pluginsDevoir="pluginsDevoir" :cutoutDg="40"
                :heightDg="160" :position="'right'" />
            </div>
          </div>
        </div>


      </div>
      <div v-if="msgs.length > 0" class="row">
        <div class="col-md-12 ">
          <div class="card margin-card">
            <h3>Forum de discussions </h3>
            <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
              <div class="spinner-border text-info" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-for="msg in msgs" :key="msg.id" class="all-msg padding-section msg__top">
              <div class="top__msg">
                <div class="all-msg__name">
                  <p> {{ msg.from.first_name }} {{ msg.from.last_name }} </p>
                </div>
                <div class="all-msg__content">
                  <p :class="{ 'arab-text': checkLanguag(reference.message) }" class="text-normal content-editor"
                    v-html="msg.message"></p>
                </div>
                <div class="all-msg__info">
                  <div class="all-msg__info__rep">
                    <button class="repondre_msg" @click="repondreMsg(msg)">Répondre</button>
                  </div>
                  <div class="all-msg__info__date">
                    <p v-if="checkLanguag(msg.message)" :class="{ 'arab-text': checkLanguag(msg.message) }"
                      class="text-date">{{ formatDateAR(msg.created_at) }}  {{ formatTimeFR(msg.created_at) }}
                    </p>
                    <p v-else :class="{ 'arab-text': checkLanguag(msg.message) }" class="text-date">{{
                      formatDateFR(msg.created_at) }}  {{ formatTimeFR(msg.created_at) }}</p>
                  </div>
                </div>
                <div class="files-list liste-padding">
                <span class="col-md-12 files-list__span" v-for="(file, index) in msg.files" :key="index"><i
                    class="icon-file-04"></i>
                  <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
                </span>
              </div>
              </div>
              <div v-if="idMsg === msg.id" class="input-container simple-input test2">
                <input v-model="yourMsg" type="text" class="form-control" placeholder="Répondre au message ...">
                <div class="icone-file">
                <label class="input-image input-files" for="otherDoc" @change="onFileChange" @click="resetFileUploader">
                  <div class="icon-upload">
                    <img src="../../assets/icons/file.png" />
                  </div>
                  <input id="otherDoc" type="file" ref="file" :multiple="true" class="d-none"
                    accept=".pdf, .xls, .xlsx, .xlsm, .docx, .ppt, .pdf, .jpeg, .jpg, .png" tabindex="-1" />
                </label>
              </div>

                <div v-if="loadingMsg" class="spinner-box icon-button ">
                  <div class="pulse-container">
                    <div class="pulse-bubble pulse-bubble-1"></div>
                    <div class="pulse-bubble pulse-bubble-2"></div>
                    <div class="pulse-bubble pulse-bubble-3"></div>
                  </div>
                </div>

                <button type="button" class="icon-button" @click="addMsg()" :disabled="btnDisplay">
                  <img src="../../assets/icons/envoi-icon.png">
                </button>

              </div>
            <div class="col-md-12 files-name file-add" v-if="tabfile.length">
              <ul class="justify-- d-flex">
                <li v-for="(item, index) in tabfile" :key="index">
                  <i class="icon-file-04"></i>
                  {{ item.name }}
                  <span class="btn-close-file" @click="deletefile(index)"></span>
                </li>
              </ul>
            </div>

              <div v-for="(response, index) in msg.responses" :key="index" class="all-msg level">
                <div class="all-msg__name">
                  <p>{{ response.from.first_name }} {{ response.from.last_name }} </p>
                </div>
                <div class="all-msg__content">
                  <p>{{ response.message }}</p>
                </div>
                <div class="all-msg__info">
                  <div class="all-msg__info__date">
                    <p>{{ formatCustomDateTime(response.created_at) }}</p>
                  </div>
                </div>
                <div class="files-list">
                <span class="col-md-12 files-list__span " v-for="(file, index) in response.files" :key="index"><i
                    class="icon-file-04"></i>
                  <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
                </span>
              </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-date-wrapper search-filter-wrapper-v1 search-filter-wrapper borderNan">
        <div class="col-md-12 search searchTeacher">
          <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshMessage()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />

        </div>
      </div>
      <div>
        <div v-if="loadingTab" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else class="general-info">
          <!-- <h1 class="justify-content-center">Liste des Parents</h1> -->
          <div v-if="listUsers.length === 0">
            <span>{{ $t("common.emptydestinataire") }}</span>
          </div>
          <div v-else>
            <div class="table message-list">
              <div class>
                <div class="row">
                  <div class="col-md-12 sub-title">
                    <h3>Suivi de la réception par destinataire</h3>
                    <div class="table__wrapper">

                      <table>
                        <thead>
                          <tr>
                            <th v-if="!children" style="width: 20%">
                              {{ $t('tabDetail.destinataire') }}
                              <div class="icon-wrapper" @click="sortB('first_name')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('first_name', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('first_name', false)]" />
                              </div>
                            </th>

                            <th v-if="children" style="width: 30%">
                              {{ $t("tabDetail.parents") }}
                              <div class="icon-wrapper" @click="sortB('full_name_parent')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('full_name_parent', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('full_name_parent', false)]" />
                              </div>
                            </th>
                            <th v-if="children" style="width: 25%">
                              {{ $t('tabDetail.student') }}
                              <div class="icon-wrapper" @click="sortB('full_name_student')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('full_name_student', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('full_name_student', false)]" />
                              </div>
                            </th>
                            <th class="envle order-from">
                              {{ $t("tabDetail.status") }}
                              <div class="icon-wrapper" @click="sortB('date_seen')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('date_seen', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('date_seen', false)]" />
                              </div>
                            </th>
                            <th class="envle order-from">
                              {{ $t("tabDetail.date") }}
                              <div class="icon-wrapper" @click="sortB('date_seen')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('date_seen', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('date_seen', false)]" />
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="eleve in listUsers" :key="eleve.id" class="item_class">
                            <td v-if="!children"><span v-if="eleve.full_name_user"><b>{{ eleve.full_name_user
                            }}</b></span><span v-else>__</span></td>
                            <td v-if="children"><span v-if="eleve.full_name_user"><b>{{ eleve.full_name_user
                            }}</b></span><span v-else>__</span></td>
                            <td v-if="children"><span v-if="eleve.full_name_student"><b v-if="!eleve.full_name_user">{{
                              eleve.full_name_student }} </b><span v-if="eleve.full_name_user">{{
    eleve.full_name_student }}</span></span><span v-else>__</span></td>
                            <td v-if="eleve.date_seen === null">
                              <span class="noActive_status"> {{ $t('common.noLu') }}</span>
                            </td>
                            <td v-else>
                              <span class="active_status">
                                {{ $t("common.lu") }}</span>
                            </td>
                            <td v-if="eleve.date_seen === null">
                              <span>__</span>
                            </td>
                            <td v-else>
                              <span> {{ formatDateFR(eleve.date_seen) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="table__wrapper__pagination-wrapper">
                        <div class="pagination">
                          <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getDetailsUsers" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

  </main>
</template>




<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import MessageService from "../../services/message.service";
import moment from "moment";
import pagination from "../../components/navigation/Pagination";
import "vue3-circle-progress/dist/circle-progress.css";
import DonutChart from "../../components/statistics/donutChart.vue";
export default {
  name: "DetailMessage",
  components: {
    TopTemplate,
    pagination,
    DonutChart,
  },
  data() {
    return {
      msgs: [],
      yourMsg: "",
      monObjetMsg: null,
      idMsg: null,
      showInputRepondre: false,
      msg: [],
      messageFrom: null,
      userMsg: null,
      displayGraph: false,
      pagination: {},
      total: 0,
      nameFrom: null,
      lastNameFrom: null,
      last_page: null,
      referenceId: null,
      percentage: null,
      loading: false,
      loadingMsg: false,
      loadingTab: false,
      listUsers: [],
      children: false,
      parentList: false,
      reference: {},
      files: [],
      pluginsDevoir: [{}],
      tabfile: [],
      btnDisplay: false,
      chartDataMessage: {
        labels: ["Lus      ", "Non lus"],
        datasets: [
          {
            backgroundColor: ["#34B9BB", "#F5A88C"],
            data: [],
            borderWidth: 2,
            borderRadius: 0,

            // angle: [50],
            // borderRadius: [{ innerStart: 50, outerStart: 50, innerEnd: 50, outerEnd: 50}],
            // spacing: -50,
          },
        ],
      },
      params: {
        q: "",
        limit: 10,
        page: 1,
        sort: "date_seen",
        order: false,
      },
      moment: null,
    };
  },
  computed: {


  },
  created() {
    this.moment = moment;
    this.referenceId = this.$route.params.id;
    const jsonString = localStorage.getItem("monObjetMsg2");
    if (jsonString) {
      this.monObjetMsg = JSON.parse(jsonString);
    }

  },
  mounted() {
    this.getDetails();
    this.getDetailsMsg();
  },
  methods: {
    deletefile(index) {
      this.tabfile.splice(index, 1);
    },
    resetFileUploader() {
      this.$refs.file.value = "";
    },
    onFileChange(event) {
      this.maxLengthFiles = false;
      const files = Object.entries(event.target.files).map(([key, value]) => value);
      const newFiles = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!this.tabfile.includes(file)) {
          newFiles.push(file);
        }
      }

      if (this.tabfile.length + newFiles.length <= 5) {
        this.tabfile = this.tabfile.concat(newFiles);
      }
      else {
        this.maxLengthFiles = true;
      }
      console.log(this.tabfile)

      this.validateFiles();
    },
    validateFiles() {
      for (let i = 0; i < this.tabfile.length; i++) {
        const file = this.tabfile[i];
        if (file.size > 2 * 1024 * 1024) {
          this.tabfile.splice(i, 1);
          this.maxFileSize = true;
          i--;
        }
      }
    },
    formatDateString(dateString) {
      const formattedDate = moment(dateString).format('DD MMMM YYYY', 'fr');
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    },
    formatCustomDateTime(dateTimeString) {
      const formattedDateTime = moment(dateTimeString).format('DD-MM-YYYY HH:mm');
      return formattedDateTime;
    },

    scrollToTop() {
      window.scrollTo({
        bottom: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    repondreMsg(msg) {
      this.showInputRepondre = true;
      this.idMsg = msg.id;
      if (this.monObjetMsg == msg.from.id) {
        this.userMsg = msg.user.id
      }
      else {
        this.userMsg = msg.from.id
      }
      this.scrollToTop();

    },
    getDetailsMsg() {
      MessageService.getConversation(this.referenceId)
        .then((response) => {
          this.msgs = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        })
    },
    addMsg(id) {
      this.btnDisplay = true;

      if (this.yourMsg) {
       this.loadingMsg = true;

        if (!this.idMsg) {
          this.idMsg = this.referenceId
        }

        //this.loading = true;
        const data = {
          message: this.yourMsg,
          user_id: this.userMsg,
          parent_id: this.idMsg,
        };

        let formData = new FormData();
          formData.append("_method", "POST");
          formData.append("message", this.yourMsg);
          formData.append("user_id", this.userMsg);
          formData.append("parent_id", this.idMsg);
          for (var i = 0; i < this.tabfile.length; i++) {
            let file = this.tabfile[i];
            formData.append("files[" + i + "]", file);
          }
        MessageService.postConversation(this.referenceId, formData)
          .then((response) => {
            this.getDetailsMsg();
            this.yourMsg = "";
            this.showInputRepondre = false
            this.idMsg = null;
            this.resetFileUploader();
            this.tabfile=[];
            this.btnDisplay = false;
          })
          .finally(() => {
            this.tabfile=[];
              this.yourMsg = "";
              this.yourMsgRepondre = "";
              this.showInputRepondre = false
              this.idMsg = null;
              this.resetFileUploader();
              //his.loading = false;
              this.btnDisplay = false;
              //this.isAddingMessage = false;
              this.loadingMsg = false;
              this.selectReponse = null;
              this.getDetailsMsg();

            //this.btnDisplay = false;
            //this.loading = false;
            //this.loadingMsg = false;

          });
      }

    },


    previewAction() {
      this.$store.dispatch("setSended", true);
      this.$router.push({
        name: "Message",
        params: { notice_status: "send" },
      });
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    formatDateFR(date) {
      return moment(date).format("DD-MM-YYYY")
    },
    formatTimeFR(date) {
      return moment(date).format("HH:MM")
    },
    formatDateAR(date) {
      return moment(date).format("YYYY-MM-DD")
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.getDetailsUsers();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.getDetailsUsers();
    },
    getDetails() {
      this.loading = true;
      MessageService.get(this.referenceId)
        .then((response) => {
          this.reference = response.data.data;
          this.files = this.reference.files;
          this.nameFrom = this.reference.from.first_name;
          this.lastNameFrom = this.reference.from.last_name;
          this.getDetailsUsers();
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.$router.push('/error-404');
          }
          console.error(error);
        })
    },
    getDetailsUsers(page = null) {
      this.loadingTab = true;
      this.params.page = !page ? this.params.page : page;
      MessageService.getListUsers(this.referenceId, {
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
        },
      })
        .then((response) => {
          this.listUsers = _.orderBy(response.data.data, "date_seen");
          this.listUsers.forEach((element, index) => {
            this.children = element.full_name_student ? true : false;
          })
          this.percentage = (this.reference.number_views / response.data.meta.total) * 100;
          let nbMsgLu = this.reference.number_views;
          let nbNotMsgLu = response.data.meta.total - this.reference.number_views;
          this.chartDataMessage.datasets[0].data = [nbMsgLu, nbNotMsgLu];
          this.displayGraph = true;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.$router.push('/error-404');
          }
          console.error(error);

        })
        .finally(() => {
          this.loading = false;
          this.loadingTab = false;
        });
    },
    makePagination(meta) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: meta.next_page_url,
        prev_page_url: meta.prev_page_url,
      };
    },
    searshMessage: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.page = 1;

        this.getDetailsUsers();
      }
    }, 200),
  },
};
</script>
<style scoped lang="scss">
.margin-card {
  margin-bottom: 25px;
}

.top-card {
  margin-bottom: 25px;
  background-color: white;
}

.sub-title h3 {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}

.name_from p {
  margin: 0;
  padding-top: 5px;
}

.all-msg.padding-section.msg__top:not(:last-child) {
  border-bottom: 1px solid #DCDCDC;
}

.all-msg.level {
  margin-left: 50px;
  border-left: 1px solid #DCDCDC;
  padding-left: 15px;
}

.level-1 {
  margin-top: 20px;
  margin-left: 80px;
  border-left: 1px solid #DCDCDC;
  padding-left: 15px;
}

.top-msg {
  padding-bottom: 20px;
}

.all-msg.padding-section.msg__top {
  padding-bottom: 20px;
  padding-top: 20px;
  margin-left: 50px;
}

h3 {
  color: #3D3D3D;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 23px;
}

.card {
  padding: 25px;
}

.top-template h3,
.top-template .h3 {
  font-weight: 700;
  font-size: 16px;
  font-family: "Montserrat";
  color: #34b9bb;
  margin-bottom: 0;
}

.content-msg {
  p {
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin: 0;

    strong {
      color: #377879;
    }
  }

  &__bottom {
    padding-top: 15px;
  }
}

.content-msg-title {
  margin-bottom: 20px;
}

.all-msg {
  padding-top: 10px;

  &__name {
    p {
      margin: 0;
      color: #377879;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 23px;
      /* 143.75% */
    }
  }

  &__content {
    p {
      color: #000;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      margin: 0;
    }
  }

  &__info {
    display: inline-flex;

    p {
      margin: 0;
    }

    .repondre_msg {
      position: relative;
      color: #F35B19;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 23px;
      padding-right: 10px;

      &::after {
        position: absolute;
        top: 5px;
        right: 0;
        width: 1px;
        height: 12px;
        background: #A098AE;
        content: "";
      }

    }

    &__rep {
      p {
        position: relative;
        color: #F35B19;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 23px;
        padding-right: 10px;

        &::after {
          position: absolute;
          top: 5px;
          right: 0;
          width: 1px;
          height: 12px;
          background: #A098AE;
          content: "";
        }
      }
    }

    &__date {
      p {
        color: #A098AE;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 23px;
        padding-left: 10px;
      }
    }
  }
}



/* Style du conteneur de l'input et du bouton icône */
.input-container {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #DCDCDC;
  padding: 6px;
  height: 35px;
  margin-top: 30px;
  margin-left: 50px;
}

/* Style de l'input */
.input-container input[type="text"] {
  flex: 1;
  border: none;
  outline: none;
  padding: 4px;
  height: 25px;
  padding-left: 35px;

  &::placeholder {
    color: #A4A8AB;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 153.846% */
  }
}

/* Style du bouton icône */
.icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
}

/* Style de l'icône */
.icon-button img {
  width: 20px;
  height: 20px;
}
.spinner-box {
  //width: 300px;
  //height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: .25;
    transform: scale(.75);
  }
}

.pulse-container {
  width: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;

}

.pulse-bubble {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #34B9BB;
}

.pulse-bubble-1 {
  animation: pulse .4s ease 0s infinite alternate;
}

.pulse-bubble-2 {
  animation: pulse .4s ease .2s infinite alternate;
}

.pulse-bubble-3 {
  animation: pulse .4s ease .4s infinite alternate;
}
.file-add {
  margin-left: 50px;
  padding-top: 0;
}
.input-image {
  padding: 0;
}

.icone-file {
  position: absolute;
  left: 5px;
  background-color: #34b9bb2b !important;
  padding: 5px !important;
  border-radius: 6px !important;
  padding-top: 3px !important;

  img {
    height: auto !important;
    width: auto !important;
  }
}
.files-list {
  &__span {
    list-style: none;
    align-items: center;
    color: #377879;
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 6px;
    font-weight: 500;
    font-weight: 500;
    padding-right: 0;

    a {
      color: #747474;
      margin-right: 7px;
    }
  }

}

.liste-padding {
  .files-list__span {
    padding-left: 0;
    padding-right: 15px;

  }
}</style>